import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({attrs:{"fab":"","x-small":"","color":"primary"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c(VIcon,[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }